import React from "react";
import LoginPage from "../login";

const SignUpPage = () => {
  return <LoginPage initialMode="signup" redirect={true} />;
};

export default SignUpPage;
